import React, { useState } from 'react';
import { useCountryQuery } from '../country/countryApiSlice';
import { useLocationQuery } from '../location/locationApiSlice';
import { useBranchQuery} from '../branch/branchApiSlice';

const SelectCountryListByLocation = ({
  setCountryId,
  setLocationId,
  setBranchId,
  isDaysFilter,
  showCountry, showLocation, showBranch
}) => {
  const [selectedCountryId, setSelectedCountryId] = useState(0);
  const [selectedLocationId, setSelectedLocationId] = useState(0);
  const [selectedBranchId, setSelectedBranchId] = useState(0);

  const {
    data: countryList,
    // error: countryErr,
    // isLoading: countryLoading,
    // isFetching: countryFetching,
    // isSuccess: countrySuccess,
  } = useCountryQuery();
  console.log('countries',countryList);

  const {
    data: locations,
    // error: locationError,
    // isLoading: locationIsLoading,
    // isFetching: locationIsFetching,
    // isSuccess: locationIsSuccess,
  } = useLocationQuery();
  console.log('locations',locations)
  
  const {
    data: branches,
    // error: branchError,
    // isLoading: branchIsLoading,
    // isFetching: branchIsFetching,
    // isSuccess: branchIsSuccess,
  } = useBranchQuery();
  console.log('branches',branches);

  const uniqueCountryIds = [
    ...new Set(locations?.data?.map((location) => location.country_id)),
  ];
  const filteredCountries = countryList?.data?.filter((country) =>
    uniqueCountryIds.some((cityId) => cityId === country.id)
  );

  console.log('uniqueCountryIds',uniqueCountryIds);
  console.log('filteredCountries',filteredCountries);

  const uniqueLocationIds = [
    ...new Set(branches?.data?.map((branch) => branch.location_id)),
  ]
  const filteredLocations = locations?.data?.filter((location) =>
    uniqueLocationIds.includes(location.id) && location.country_id === Number(selectedCountryId)
  );

  // // Filtered Branches based on selected location
  // const filteredBranches = branches?.data?.filter(
  //   (branch) => branch.location_id === Number(selectedLocationId)
  // );

  // console.log('filteredLocations',filteredLocations);
  // console.log('uniqueLocationIds',uniqueLocationIds);
  // console.log('filtered Branches',filteredBranches)

  // console.log('uniqueCountry',uniqueCountryIds);
  // console.log('filteredCountries',filteredCountries);

  const reset = () => {
    setSelectedCountryId(0);
    setSelectedLocationId(0);
    setSelectedBranchId(0);
    setCountryId(0);
    setLocationId(0);
    setBranchId(0);
  };

  return (
    <div className="text-white flex space-x-2">
      {showCountry && (<select
        name="countrylist"
        id="countrylist"
        className="bg-[#fff] text-[13px] text-black text-xs w-20"
        value={selectedCountryId}
        onChange={(e) => {
          setSelectedCountryId(e.target.value);
          setSelectedLocationId(0);
          setCountryId(e.target.value);
          setLocationId(0);
        }}
      >
        <option value="0">Country</option>
        {filteredCountries?.map((country) => (
          <option key={country.id} value={country.id}>
            {country.country_name}
          </option>
        ))}
      </select>
      )}
      {showLocation && (
        <select
        name="locationlist"
        id="locationlist"
        className="bg-[#fff] text-[13px] text-black text-xs w-20"
        onChange={(e) => {
          setSelectedLocationId(e.target.value);
          setLocationId(e.target.value);
        }}
        value={selectedLocationId}
      >
        <option value="0">Location</option>
        {locations?.data
          .filter((location) => location.country_id == selectedCountryId)
          .map((location) => (
            <option id={location.id} value={location.id}>
              {location?.name}
            </option>
          ))}
      </select>
      )}
      {showBranch && (
        <select 
        name="branchList"
        id="branchesList"
        className="bg-[#fff] text-[13px] text-black text-xs w-20"
        onChange={(e) => {
          setSelectedBranchId(e.target.value);
          setBranchId(e.target.value);
        }}
        value={selectedBranchId}
        >
          <option value="0">Branch</option>
          {branches?.data
            .filter((branch) =>branch.location_id == selectedLocationId)
            .map((branch)=> (
              <option id={branch.id} value={branch.id}>
                {branch?.name}
              </option>
            ))}
        </select>
      )}
      

      {isDaysFilter && (
        <select
          name=""
          id=""
          className=" bg-[#fff] text-[13px] text-black  text-xs w-20"
        >
          <option value="30">30 Days</option>
          <option value="60">60 Days</option>
        </select>
      )}
      <button
        onClick={reset}
        className="text-xs border border-1 px-3 py-1 text-black rounded-xl"
      >
        Reset
      </button>
    </div>
  );
};

export default SelectCountryListByLocation;
